import { cva, VariantProps } from 'class-variance-authority'
import { ComponentProps, ReactNode } from 'react'
import { cn } from '~utils/cn'

import { ButtonPriority, ButtonSize } from '.'

export type TextButtonPriority = Exclude<ButtonPriority, 'secondary'>

export type TextButtonProps = Readonly<
  ComponentProps<'button'> &
    VariantProps<typeof textButtonStyle> & {
      children: ReactNode
      priority?: TextButtonPriority
      size?: Exclude<ButtonSize, 'medium'>
    }
>

const textButtonStyle = cva(['cursor-pointer', 'disabled:cursor-default'], {
  variants: {
    priority: {
      primary: ['text-primary-600', 'disabled:text-gray-400'],
      tertiary: ['text-gray-700', 'disabled:text-gray-300'],
      destructive: ['text-red-500', 'disabled:text-red-100'],
    },
    size: {
      large: ['text-title-3 px-2 py-4'],
      small: ['text-label-1 p-2'],
    },
  },
  defaultVariants: {
    priority: 'tertiary',
    size: 'small',
  },
})

/**
 * @version v1.1.0
 * @author Danny
 * @description tertiary 버튼 텍스트 색상 변경
 */
const TextButton = ({ children, priority, size, ...props }: TextButtonProps) => {
  const { className } = props

  return (
    <button {...props} type="button" className={cn(textButtonStyle({ priority, size }), className)}>
      {children}
    </button>
  )
}

export default TextButton
